import { Button, Grid } from "@mui/material";
import React from "react";
import { HelpDialog } from "./HelpDialog";
import * as Flags from "country-flag-icons/react/3x2";

interface Props {
  open: boolean;
  onClose: () => void;
}

const SAFE_COUNTRIES = [
  {
    name: "Andorra",
    Flag: Flags.AD,
  },
  {
    name: "Argentina",
    Flag: Flags.AR,
  },
  {
    name: "Austria",
    Flag: Flags.AT,
  },
  {
    name: "Azerbaijan",
    Flag: Flags.AZ,
  },
  {
    name: "Belgium",
    Flag: Flags.BE,
  },
  {
    name: "Bulgaria",
    Flag: Flags.BG,
  },
  {
    name: "Canada",
    Flag: Flags.CA,
  },
  {
    name: "Croatia",
    Flag: Flags.HR,
  },
  {
    name: "Cyprus",
    Flag: Flags.CY,
  },
  {
    name: "Czech Republic",
    Flag: Flags.CZ,
  },
  {
    name: "Denmark",
    Flag: Flags.DK,
  },
  {
    name: "Estonia",
    Flag: Flags.EE,
  },
  {
    name: "Faroe Islands",
    Flag: Flags.FO,
  },
  {
    name: "Finland",
    Flag: Flags.FI,
  },
  {
    name: "France",
    Flag: Flags.FR,
  },
  {
    name: "Germany",
    Flag: Flags.DE,
  },
  {
    name: "Greece",
    Flag: Flags.GR,
  },
  {
    name: "Guernsey",
    Flag: Flags.GG,
  },
  {
    name: "Hungary",
    Flag: Flags.HU,
  },
  {
    name: "Iceland",
    Flag: Flags.IS,
  },
  {
    name: "Ireland",
    Flag: Flags.IE,
  },
  {
    name: "Isle of Man",
    Flag: Flags.IM,
  },
  {
    name: "Israel",
    Flag: Flags.IL,
  },
  {
    name: "Italy",
    Flag: Flags.IT,
  },
  {
    name: "Japan",
    Flag: Flags.JP,
  },
  {
    name: "Jersey",
    Flag: Flags.JE,
  },
  {
    name: "Latvia",
    Flag: Flags.LV,
  },
  {
    name: "Liechtenstein",
    Flag: Flags.LI,
  },
  {
    name: "Lithuania",
    Flag: Flags.LT,
  },
  {
    name: "Luxembourg",
    Flag: Flags.LU,
  },
  {
    name: "Malta",
    Flag: Flags.MT,
  },
  {
    name: "Netherlands",
    Flag: Flags.NL,
  },
  {
    name: "New Zealand",
    Flag: Flags.NZ,
  },
  {
    name: "Norway",
    Flag: Flags.NO,
  },
  {
    name: "Poland",
    Flag: Flags.PL,
  },
  {
    name: "Portugal",
    Flag: Flags.PT,
  },
  {
    name: "Romania",
    Flag: Flags.RO,
  },
  {
    name: "Slovenia",
    Flag: Flags.SI,
  },
  {
    name: "Slovakia",
    Flag: Flags.SK,
  },
  {
    name: "South Korea",
    Flag: Flags.KR,
  },
  {
    name: "Spain",
    Flag: Flags.ES,
  },
  {
    name: "Sweden",
    Flag: Flags.SE,
  },
  {
    name: "Switzerland",
    Flag: Flags.CH,
  },
  {
    name: "United Kingdom",
    Flag: Flags.GB,
  },
  {
    name: "Uruguay",
    Flag: Flags.UY,
  },
];

export const SafeCountriesDialog: React.FC<Props> = ({ open, onClose }) => {
  return (
    <HelpDialog
      open={open}
      onClose={onClose}
      title={"Safe Countries"}
      actions={
        <Button variant="contained" color="primary" onClick={onClose}>
          Close
        </Button>
      }
      disableBackdropClick={true}
      className="intro-help-dialog"
      maxWidth="md"
    >
      <DialogBody />
    </HelpDialog>
  );
};

const DialogBody = () => {
  return (
    <Grid container spacing={2}>
      {SAFE_COUNTRIES.map(({ name, Flag }) => (
        <Grid key={name.replace(" ", "_")} item xs={6} sm={4} className="d-flex align-items-center">
          <Flag width="40" className="mr-md box-rounded border" /> {name}
        </Grid>
      ))}
    </Grid>
  );
};
